import React from "react";

const PurchaseSettingsTab = () => {
  return;
};

export default PurchaseSettingsTab;
